<template>
  <div  class="width-100" v-if="getPermission('setting:view')">
    <perfect-scrollbar
      :options="{ suppressScrollX: true }"
      class="scroll custom-box-top-inner-shadow"
      style="max-height: 85vh; position: relative"
    >
      <v-card flat class="custom-grey-border remove-border-radius mt-4">
        <v-card-title class="headline grey lighten-4">
          <h3
            class="font-weight-700 custom-headline color-custom-blue"
            style="margin: 3.5px 0px"
          >
            Payment Terms
          </h3>
        </v-card-title>
        <v-card-text
          class="p-6 font-size-16"
          :class="{ 'pointer-events-none': !getPermission('setting:update') }"
        >
          <v-row>
            <v-col md="12" class="pb-4">
             <quotation-note-template
                  :quote-type="quoteTypeTab"
                  :key="`quotation-note-${quoteTypeTab}`"
                />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
   
    </perfect-scrollbar>
  </div>
</template>

<script>

import QuotationNoteTemplate from "./QuotationNoteTemplate.vue";

export default {
  name: "quotation-notes-setting",
  data() {
    return {
      titles: [],
      pageLoading: true,
      quoteTypeTab: "new",
    };
  },
  components: {
    QuotationNoteTemplate,
  },
  methods: {
    
  
  },
  mounted() {
    
  },
};
</script>
